import React from 'react';
import { FieldError } from 'react-hook-form';
import { useLazyPrescriptionMedicamentQuery } from '../../../graphql/graphql';
import DynamicSelect from '../../../Components/Base/DynamicSelect/DynamicSelect';
import { SelectValue } from '../../../Components/Base/Select/Select';
import PrescriptionMedicamentSelectItem from './PrescriptionMedicamentSelectItem';

interface Props {
	onChange?: (value: SelectValue) => void;
	workplaceId?: string;
	value?: {
		id: string;
		label: string;
	};
	error?: FieldError;
}

const PrescriptionMedicamentsSelect: React.FC<Props> = ({
	value,
	onChange,
}) => {
	const [searchMedicaments] = useLazyPrescriptionMedicamentQuery();

	const handleSearchItem = async (
		searchInput: string,
	): Promise<SelectValue[]> => {
		const { prescriptionMedicaments } = await searchMedicaments({
			search: searchInput,
		}).unwrap();

		const items: SelectValue[] = [];

		for (const prescriptionMedicament of prescriptionMedicaments?.data || []) {
			if (prescriptionMedicament) {
				items.push({
					value: prescriptionMedicament.id,
					label: '',
					item: prescriptionMedicament,
				});
			}
		}

		return items;
	};

	return (
		<DynamicSelect
			searchItems={handleSearchItem}
			value={value ? { value: value.id, label: value.label } : undefined}
			onChange={onChange}
			ItemTemplate={PrescriptionMedicamentSelectItem}
		/>
	);
};

export default PrescriptionMedicamentsSelect;
